;(function() {
  'use strict'

  directive.$inject = ["$window", "$timeout"];
  angular.module('core.fbLikeButton').directive('fbLikeButton', directive)

  /* @ngInject */
  function directive($window, $timeout) {
    return {
      restrict: 'E',
      scope: {
        url: '@',
      },
      templateUrl: 'fb-like-button.template.html',
      link: link,
    }

    function link(scope, elem) {
      elem.addClass('fb-like-button')
      $timeout(function() {
        $window.FB.XFBML.parse(elem[0])
      })
    }
  }
})()
